import { alpha } from '@mui/material';

export default alpha;
